import React, { useRef, useState } from 'react';
import { faCalendarAlt, faSave, faMapMarkedAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import FichaVistoria from './FichaVistoria';
import TabelaAgendamentos from './components/TabelaAgendamentos';
import CustomizedMap from '../../../components/CustomizedMap/CustomizedMap';
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Api
import setor_api from '../../../api/setor_api';
import cep_api from '../../../api/cep_api';
import usuario_api from '../../../api/usuario_api';
import solicitacaoVistoria_api from '../../../api/solicitacaoVistoria_api';
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import ramoDeAtividade_api from '../../../api/ramoDeAtividade_api';
import gerador_api from '../../../api/gerador_api';
import transportador_api from '../../../api/transportador_api';

//Helpers
import { showMessage, showQuestion } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Shared
import FiltroPrefeitura from '../../../views/Shared/FiltroPrefeitura';
import FichaAgendamento from './components/FichaAgendamento';

//Context
import { useAuth } from '../../../context/auth';

//Estado inicial da nova vistoria
function initialStateNovaVistoria() {
    return {
        nomeSolicitante: "",
        dataSolicitacao: "",
        motivoFiscalizacao: "",
        identificacaoLocalidade: "",
        cep: "",
        email: "",
        uf: "",
        cidade: "",
        bairro: "",
        logradouro: "",
        numero: "",
        complemento: "",
        tbSetores_Id: "",
        cpfcnpj: "",
        status: "Pendente",
        tbTipoColeta_Id: "",
        tbSegmentos_Id: "",
        agendamentos: [],
        dataValidadeCadastro: "",
        entidadeFiscalizada: "Gerador"
    }
}

//Estado inicial do novo agendamento
function initialStateNovoAgendamento() {
    return {
        tbUsuario_Id: "",
        dataAgendamento: "",
        observacoes: "",
        status: "Agendado"
    }
}
export default function NovaVistoria({ btnVoltar, disabled = false, vistoriaFicha }) {
    const { session, setupVariavel } = useAuth();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de erros da solicitação
    const [errors, setErrors] = useState({});

    //Estado que guarda os erros no agendamento
    const [errorsAgendamento, setErrorsAgendamento] = useState({});

    //Estado que guarda o valor para apresentar a ficha do agendamento
    const [fichaVistoria, setFichaVistoria] = useState(null);

    //Estado de controle de mudança do estado de disable dos campos
    const [disabledFields, setDisabledFields] = useState(disabled);

    //Estado de controle das opções de regionais no select
    const [optionsRegionais, setOptionsRegionais] = useState([]);

    //Estado de controle das opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Estado de controle do id da prefeitura
    const [prefeitura_Id, setPrefeitura_Id] = useState();

    //Estado inicial do campos da nova vistoria
    const [vistoria, setVistoria] = useState((initialStateNovaVistoria()));

    //Estado de controle dos campos de agendamentos
    const [agendamento, setAgendamento] = useState(initialStateNovoAgendamento);

    //Estado de editar o agendamento
    const [editarAgendamento, setEditarAgendamento] = useState(null);

    //Estado que guarda as opções dos fiscais
    const [optionsFiscais, setOptionsFiscais] = useState([]);

    //Estado que guarda as opções dos ramos de atividade
    const [optionsRamos, setOptionsRamos] = useState([]);

    //Estado de controle do gerador que foi encontrado com o cpf/cnpj informado
    const [gerador, setGerador] = useState("");

    //Referencia do relatorio
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "vistoria",
    });

    //Headers da tabela de listagem de agendamentos
    const headers = [
        { value: "Fiscal", objectValue: "fiscal", align: "left" },
        { value: "Data do agendamento", objectValue: "dataAgendamento", align: "left" },
        { value: "Status", objectValue: "status", align: "right" },
        { value: "Observações", objectValue: "observacoes", align: "right" },
        { value: "Enquadramento", objectValue: "resultado", align: "right" },
    ]


    //Campos obrigatorios da solicitação de vistoria
    const [camposVistoria, setCamposVistoria] = useState([
        objCampo({ name: "dataSolicitacao", required: true }),
        objCampo({ name: "identificacaoLocalidade", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "tbSetores_Id", required: true }),
        objCampo({ name: "tbTipoColeta_Id", required: true }),

    ])

    const oprionsEntidadeFiscalizada = [
        { text: "Gerador", value: "Gerador" },
        { text: "Transportador", value: "Transportador" },
    ];

    //Campos obrigatorios para cadastrar o agendamento
    const camposAgendamento = [
        objCampo({ name: "tbUsuario_Id", required: true }),
        objCampo({ name: "dataAgendamento", required: true })
    ]

    //OnChange para os campos da vistoria
    const onChangeVistoria = (e) => {
        const { name, value } = e.target;
        const _vistoria = {
            ...vistoria,
            [name]: value
        }
        const campo = camposVistoria.filter(c => c.name === name);
        const erroCampo = validarCampos(_vistoria, campo);
        if (erroCampo[1].length > 0) {
            setErrors({
                ...errors,
                ...erroCampo[0]
            })
        } else {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors({ ..._errors });
        }
        setVistoria(_vistoria);
    }

    //Função que carrega a lista de regionais
    const loadRegionais = (prefeitura_id) => {
        setLoading(true);
        setor_api.GetList(prefeitura_id).then(response => {
            setOptionsRegionais([...response.data.map(value => { return { label: value.descricao, value: value.id.toString() } })])
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Função que carrega os fiscais
    const loadFiscais = (setorId) => {
        usuario_api.getListByPerfil("Fiscal", setorId).then(response => {
            setOptionsFiscais([...response.data.map(value => { return { label: value.nome, value: value.id.toString() } })]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Função que carrega a lista de modalidades
    const loadModalidades = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { label: value.descricao, value: value.id.toString() };
            });
            setOptionsModalidades(response.data);
        }).catch(e => {
            showMessage("Aviso!", e.message, "error", null);
        }).finally(f => { setLoading(false); });
    }

    //Função que carrega a lista de ramos de atividade
    const loadRamosDeAtividade = () => {
        setLoading(true);
        ramoDeAtividade_api.GetList().then(response => {
            response.data = response.data.map(value => { return { label: value.descricao, value: value.id.toString() } });
            setOptionsRamos(response.data);
        }).catch(e => showMessage("Aviso!", e.message, "error"))
            .finally(f => setLoading(false));
    }

    function extractDate(dateTime) {
        if (dateTime.includes('T')) {
            return dateTime.split('T')[0];
        }
        return dateTime;
    }

    const loadGeradorPorCPFCNPJ = () => {
        if (vistoria.cpfcnpj.length < 11) return;
        if (vistoria.entidadeFiscalizada == "Gerador") {
            setLoading(true);
            gerador_api.GetItemByCpfCnpj(vistoria.cpfcnpj).then(response => {
                response.data = response.data == "" ? null : response.data;
                setGerador(response.data);

                if (!!response.data)
                    setVistoria({ ...vistoria, dataValidadeCadastro: extractDate(response.data.dataValidade) })
                else
                    setVistoria({ ...vistoria, dataValidadeCadastro: "" })

            }).catch(e => showMessage("Aviso!", e.message, "error", null))
                .finally(f => setLoading(false));
        } else if (vistoria.entidadeFiscalizada == "Transportador") {
            setLoading(true);
            transportador_api.GetItemByCnpj(vistoria.cpfcnpj)
                .then(response => {
                    if (!response.data) {
                        showMessage("Aviso!", "Transportador não encontrado com esse CPF/CNPJ.", "error", null, () => {
                            setVistoria({ ...vistoria, cpfcnpj: "", dataValidadeCadastro: "" });
                        });
                        return;
                    }
                    if (!!response.data.credenciamentoValidade)
                        setVistoria({ ...vistoria, dataValidadeCadastro: extractDate(response.data.credenciamentoValidade) })

                })
                .catch(e => showMessage("Aviso!", e.message, "error", () => {
                    setVistoria({ ...vistoria, cpfcnpj: '' });
                }))
                .finally(f => setLoading(false));
        }
    }
    //Função que faz o controle do id da prefeitura e carrega as regionais
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        loadRegionais(value);
        loadRamosDeAtividade();
        loadModalidades();
        if (vistoriaFicha) {
            setLoading(true);
            solicitacaoVistoria_api.GetItem(vistoriaFicha).then(response => {
                response.data.tbTipoColeta_Id = response.data.tbTipoColeta_Id.toString();
                response.data.dataSolicitacao = moment(response.data.dataSolicitacao).format("YYYY-MM-DD");
                response.data.tbSetores_Id = response.data.tbSetores_Id.toString();

                if (!!response.data.dataValidadeCadastro)
                    response.data.dataValidadeCadastro = extractDate(response.data.dataValidadeCadastro);

                setVistoria(response.data);
                loadFiscais(response.data.tbSetores_Id);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //OnBlur para o campo de cep do endereço
    const onBlurCep = (e) => {
        const { name, value } = e.target;
        const _vistoria = {
            ...vistoria,
            [name]: value
        }
        _vistoria.cep = mascaras.cepMask(_vistoria.cep, true);
        if (_vistoria.cep.length == 8) {
            setLoading(true);
            cep_api.get(_vistoria.cep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _vistoria.bairro = response.data.bairro;
                _vistoria.uf = response.data.uf;
                _vistoria.logradouro = response.data.logradouro;
                _vistoria.cidade = response.data.localidade;
                if (response.data.setor_Id) {
                    _vistoria.tbSetores_Id = response.data.setor_Id.toString();

                }
                loadFiscais(!!response.data.setor_Id ? response.data.setor_Id : 0);
                setLoading(true);

                const endereco = {
                    NumeroCep: _vistoria.cep,
                    Bairro: _vistoria.bairro,
                    Logradouro: _vistoria.logradouro,
                    Cidade: _vistoria.cidade,
                    Estado: _vistoria.uf,
                    Numero: _vistoria.numero,
                    Latitude: "",
                    Longitude: "",
                }

                cep_api.GeoCode(endereco).then(response => {
                    if (response.data.latitude && response.data.longitude) {
                        _vistoria.latitude = parseFloat(response.data.latitude.replace(",", "."));
                        _vistoria.longitude = parseFloat(response.data.longitude.replace(",", "."));
                    }
                    setVistoria({ ..._vistoria });
                }).catch(e => {
                    showMessage("Aviso", e.message, "error");
                }).finally(f => setLoading(false));

            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }


    //Função de onChange dos campos de agendamento
    const onChangeAgendamento = (e) => {
        const { name, value } = e.target;
        const _agendamento = {
            ...agendamento,
            [name]: value
        };

        setAgendamento(_agendamento);
    }

    //Função de onChange do campo de fiscal do agendamento
    const onChangeFiscalAgendamento = (e, select) => {
        setAgendamento({
            ...agendamento,
            [select.name]: e && e.value ? e.value : "",
            fiscal: e && e.value ? e.label : ""
        })
    }

    //Função de onChange do campo de fiscal do agendamento
    const onChangeSelect = (e, select) => {
        setVistoria({
            ...vistoria,
            [select.name]: e && e.value ? e.value : ""
        })
    }

    //onChange do campo de selecionar setor
    const onChangeSetor = (e, select) => {
        loadFiscais(e && e.value ? e.value : 0);
        setVistoria({
            ...vistoria,
            [select.name]: e && e.value ? e.value : ""
        })
    }

    //Função que adiciona um novo agendamento a lista
    const adicionarAgendamento = () => {
        const _errors = validarCampos(agendamento, camposAgendamento);

        setErrorsAgendamento({ ..._errors[0] })
        if (_errors[1].length > 0) {
            return;
        }

        setVistoria({
            ...vistoria,
            agendamentos: [...vistoria.agendamentos, { ...agendamento }],
        });
        setAgendamento(initialStateNovoAgendamento);
    }

    //Change para o mapa pegando a longitude e latitude
    const onChangeLocation = (location) => {
        if (!disabledFields)
            setVistoria({ ...vistoria, latitude: location.lat, longitude: location.lng })
    }

    //Função que cria/edita  a solicitação de vistoria
    const salvarSolicitacao = () => {
        const _errors = validarCampos(vistoria, camposVistoria);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        if ((vistoria.cpfcnpj.length > 0 && vistoria.email.length == 0) || (vistoria.cpfcnpj.length == 0 && vistoria.email.length > 0)) {
            showMessage("Sucesso", "O campo Email e o campo CPF/CNPJ precisam ser preenchidos.", "warning", null);
            return;
        }
        setLoading(true);
        if (!vistoria.id) {
            solicitacaoVistoria_api.Post(vistoria).then(response => {
                showMessage("Sucesso", "Sucesso ao cadastrar a solicitação", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            const _vistoria = { ...vistoria };
            if (_vistoria.status == "Pendente" && _vistoria.agendamentos.filter(a => a.status === "Agendado").length > 0) {
                _vistoria.status = "Agendada"
            }
            solicitacaoVistoria_api.Put(_vistoria).then(response => {
                showMessage("Sucesso", "Sucesso ao atualizar a solicitação", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Função que remove o agendamento da tabela
    const removerAgendamento = (rowData) => {
        const _agendamentos = vistoria.agendamentos.filter((a, index) => rowData.tableData.id !== index);
        setVistoria({
            ...vistoria,
            agendamentos: [..._agendamentos]
        })
    }

    //Ações da tabela
    const actions = [
        (rowData) => {
            if (!rowData.id)
                return actionsTable.remover(() => showQuestion("Tem certeza disso?", "Esta é uma ação irreversivel, deseja mesmo remover este item?", "warning", () => removerAgendamento(rowData)))
        },
        (rowData) => {
            if (rowData.status === "Executado")
                return actionsTable.visualizar(() => setFichaVistoria(rowData.id));
        },
        (rowData) => {
            if (rowData.status != "Executado")
                return actionsTable.editar((rowData) => {
                    setEditarAgendamento({ id: rowData.id, solicitacaoVistoriaId: rowData.tbSolicitacaoVistoria_Id })

                })
        }
    ]

    if (fichaVistoria) {
        return <FichaVistoria btnVoltar={() => setFichaVistoria(null)} agendamentoId={fichaVistoria} />
    }
    if (editarAgendamento) {
        return <FichaAgendamento btnVoltar={btnVoltar} editarAgendamento={editarAgendamento} />
    }

    return (
        <MainCard
            btnVoltarInTop={btnVoltar}
            btnEditarInTop={vistoriaFicha && vistoria.status != "Finalizada" && vistoria.status != "Em Execução" && vistoria.status != "Arquivada" ? () => setDisabledFields(!disabledFields) : null}
            btnImprimir={handlePrint}
        >
            {loading && <Loading />}
            <FiltroPrefeitura
                handleValue={handlePrefeitura}
            />
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print d-flex align-items-center justify-content-between px-2">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-none imageHeader">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                    </div>
                }
                <div className='row mb-4 noPrint'>
                    <div className='col-sm-12 col-lg-12'>
                        <span className="text-danger fw-bold">*</span> Campos obrigatórios
                    </div>
                </div>
                <div className="m-2 body">
                    <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faPencilAlt} /> Identificação</h5>
                    <div className='row'>
                        <div className="col-md-12 col-lg-6">
                            <TextField
                                maxLength={"150"}
                                invalid={errors.nomeSolicitante}
                                disabled={disabledFields}
                                label={"* Solicitante"}
                                name="nomeSolicitante"
                                value={vistoria.nomeSolicitante}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <TextField
                                disabled={disabledFields}
                                label={"* Data da Solicitação"}
                                type="date"
                                name="dataSolicitacao"
                                value={vistoria.dataSolicitacao}
                                invalid={errors.dataSolicitacao}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-12">
                            <TextField
                                type={"textarea"}
                                maxLength={"500"}
                                disabled={disabledFields}
                                label={"Motivação da fiscalização"}
                                name="motivoFiscalizacao"
                                value={vistoria.motivoFiscalizacao}
                                invalid={errors.motivoFiscalizacao}
                                onChange={onChangeVistoria}
                            />
                        </div>
                    </div>
                    <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faMapMarkedAlt} /> Dados da Fiscalização</h5>
                    <div className='row'>
                        <Col className="col-md-12 col-lg-4">
                            <TextField
                                invalid={!!errors.entidadeFiscalizada}
                                label={"* Ente Fiscalizado"}
                                options={oprionsEntidadeFiscalizada}
                                type="select"
                                onChange={onChangeVistoria}
                                name={"entidadeFiscalizada"}
                                value={vistoria.entidadeFiscalizada}
                            />
                        </Col>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"300"}
                                disabled={disabledFields}
                                label={"* Identificação da localidade"}
                                name="identificacaoLocalidade"
                                value={vistoria.identificacaoLocalidade}
                                invalid={errors.identificacaoLocalidade}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"18"}
                                mask={mascaras.cpfcnpjMask}
                                disabled={disabledFields}
                                label={"CPF / CNPJ"}
                                name="cpfcnpj"
                                value={vistoria.cpfcnpj}
                                invalid={errors.cpfcnpj}
                                onChange={onChangeVistoria}
                                onBlur={loadGeradorPorCPFCNPJ}
                            />
                            <PrintValidate
                                field={"cpfcnpj"}
                                errors={errors}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"100"}
                                disabled={disabledFields}
                                label={"Email"}
                                name="email"
                                value={vistoria.email ?? ""}
                                invalid={errors.email}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        {!!vistoria.dataValidadeCadastro &&
                            <div className="col-md-12 col-lg-4">
                                <TextField
                                    disabled={true}
                                    type={"date"}
                                    label={"Data validade cadastro"}
                                    value={vistoria.dataValidadeCadastro}
                                    name="dataValidadeCadastro"
                                    onChange={onChangeVistoria}
                                />
                            </div>
                        }
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"9"}
                                disabled={disabledFields}
                                label={"* CEP"}
                                value={vistoria.cep}
                                invalid={errors.cep}
                                name="cep"
                                onChange={onChangeVistoria}
                                mask={mascaras.cepMask}
                                onBlur={onBlurCep}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"2"}
                                disabled={disabledFields}
                                label={"* UF"}
                                value={vistoria.uf}
                                invalid={errors.uf}
                                name="uf"
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"150"}
                                disabled={disabledFields}
                                label={"* Cidade"}
                                name="cidade"
                                value={vistoria.cidade}
                                invalid={errors.cidade}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"100"}
                                disabled={disabledFields}
                                label={"* Bairro"}
                                name="bairro"
                                value={vistoria.bairro}
                                invalid={errors.bairro}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"300"}
                                disabled={disabledFields}
                                label={"* Logradouro"}
                                name="logradouro"
                                value={vistoria.logradouro}
                                invalid={errors.logradouro}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"50"}
                                disabled={disabledFields}
                                label={"* Número"}
                                name="numero"
                                value={vistoria.numero}
                                invalid={errors.numero}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                disabled={disabledFields}
                                label={"* Regional"}
                                name="tbSetores_Id"
                                invalid={errors.tbSetores_Id}
                                value={optionsRegionais.filter(v => v.value === vistoria.tbSetores_Id)[0]}
                                type="select" options={optionsRegionais}
                                onChange={onChangeSetor}
                                searchable />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"200"}
                                disabled={disabledFields}
                                label={"Complemento"}
                                name="complemento"
                                value={vistoria.complemento}
                                invalid={errors.complemento}
                                onChange={onChangeVistoria}
                            />
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <TextField
                                maxLength={"200"}
                                disabled={disabledFields}
                                label={"* Modalidade de coleta"}
                                type={"select"}
                                searchable
                                options={optionsModalidades}
                                name="tbTipoColeta_Id"
                                value={optionsModalidades.filter(v => v.value === vistoria.tbTipoColeta_Id)[0]}
                                invalid={errors.tbTipoColeta_Id}
                                onChange={onChangeSelect}
                            />
                        </div>
                        {!!vistoria.resultadoFinal &&
                            <div className="col-md-12 col-lg-4">
                                <TextField
                                    maxLength={"200"}
                                    disabled={disabledFields}
                                    label={"Resultado Final"}
                                    type={"text"}
                                    name="resultadoFinal"
                                    value={vistoria.resultadoFinal}
                                />
                            </div>
                        }
                        {gerador == null && vistoria && vistoria?.cpfcnpj?.length > 0 && vistoria?.email?.length > 0
                            ?
                            <div className="col-md-12 col-lg-4">
                                <TextField
                                    maxLength={"200"}
                                    disabled={disabledFields}
                                    label={"* Ramo de atividade"}
                                    type={"select"}
                                    searchable
                                    options={optionsRamos}
                                    name="tbSegmentos_Id"
                                    value={optionsRamos.filter(v => v.value == vistoria.tbSegmentos_Id)[0]}
                                    invalid={errors.tbSegmentos_Id}
                                    onChange={onChangeSelect}
                                />
                            </div>
                            :
                            <></>
                        }
                    </div>
                </div>
                <Row className='d-flex align-items-center justify-content-center'>
                    <div
                        className='col-md-12 col-lg-12 shadow rounded-3 overflow-hidden m-0 p-0 mb-4'
                        style={{ width: "80%", height: "250px" }}
                    >
                        <CustomizedMap
                            positionCenter
                            addNewMarker
                            position={{ lat: vistoria.latitude ? vistoria.latitude : "", lng: vistoria.longitude ? vistoria.longitude : "" }}
                            setPosition={onChangeLocation}
                            zoom={19}
                        />
                    </div>
                </Row>
                <h5 className="bg-gradient bg-primary rounded-3 text-light p-1"><FontAwesomeIcon icon={faCalendarAlt} /> Agendamentos</h5>
                {vistoria.agendamentos.filter(a => a.status === "Agendado").length === 0 && vistoria.status != "Finalizada" &&
                    <div className='row noPrint'>
                        <div className='col-md-12 col-lg-4'>
                            <TextField
                                disabled={vistoria.status != "Em Execução" && disabledFields}
                                options={optionsFiscais}
                                label={"* Fiscal"}
                                type="select"
                                name="tbUsuario_Id"
                                invalid={!!errorsAgendamento.tbUsuario_Id}
                                value={optionsFiscais.filter(v => v.value === agendamento.tbUsuario_Id)[0]}
                                onChange={onChangeFiscalAgendamento}
                                searchable
                            />
                        </div>
                        <div className='col-md-12 col-lg-4'>
                            <TextField
                                disabled={vistoria.status != "Em Execução" && disabledFields}
                                label={"* Data de agendamento"}
                                type="date"
                                name="dataAgendamento"
                                invalid={!!errorsAgendamento.dataAgendamento}
                                value={agendamento.dataAgendamento}
                                onChange={onChangeAgendamento}
                            />
                        </div>
                        <div className='col-md-12 col-lg-4'>
                            <TextField
                                disabled={vistoria.status != "Em Execução" && disabledFields}
                                label={"* Observações"}
                                name="observacoes"
                                invalid={!!errorsAgendamento.observacoes}
                                value={agendamento.observacoes}
                                onChange={onChangeAgendamento}
                            />
                        </div>
                        <div className='col-md-12 col-lg-4'>
                            <Button
                                color='primary'
                                className='mb-3'
                                onClick={adicionarAgendamento}
                            >
                                + Adicionar
                            </Button>
                        </div>
                    </div>
                }
                <div className='w-100 noPrint'>
                    <TabelaAgendamentos
                        actions={actions}
                        items={vistoria.agendamentos}
                    />
                </div>
                <div className='w-100 print'>
                    <TabelaListagemFichas
                        headers={headers}
                        items={vistoria.agendamentos.map(value => {
                            const _value = { ...value };
                            _value.dataAgendamento = moment(_value.dataAgendamento).format("DD/MM/YYYY");
                            return _value;
                        })}
                        width={100}
                        scrollbar={false}
                    />
                </div>
            </div>
            <div className=' d-flex align-items-center justify-content-center mt-3 mb-3 '>
                {(vistoria.status == "Em Execução" || !disabledFields) && <Button
                    color={'success'}
                    onClick={salvarSolicitacao}
                >
                    {<><FontAwesomeIcon icon={faSave} /> Salvar</>}
                </Button>
                }
            </div>
        </MainCard>
    )
}